export default {
  "name": "NCTabs",
  "column": 1,
  "canAppend": true,
  "type": 1,
  "path": "LowCodeComponents.NCTabs",
  "label": "页签",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "activeKey": {
        "title": "activeKey",
        "description": "激活的tabPanel的key",
        "type": "string"
      },
      "tabBarPosition": {
        "title": "tabBarPosition",
        "description": "tab头的定位",
        "type": "enum",
        "enum": [
          "left",
          "right",
          "top",
          "bottom"
        ]
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}